import { useDroppable } from '@dnd-kit/core'
import { Flex } from 'antd'
import { memo } from 'react'

import { useStyles } from './styles'
import { COLUMN_DROPPABLE_PREFIX } from './utils'

type SortableItemProps = {
  id: number | string
  children: React.ReactNode
}

const KanbanDroppableContent = ({ id, children }: SortableItemProps) => {
  const { styles } = useStyles()

  const { setNodeRef } = useDroppable({
    id: `${COLUMN_DROPPABLE_PREFIX}${id}`
  })

  return (
    <Flex ref={setNodeRef} vertical gap={16} className={styles.columnDroppable}>
      {children}
    </Flex>
  )
}

export const KanbanDroppable = memo(KanbanDroppableContent)
